import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import Slider from 'react-slick'
import Cards from '../Cards/Cards';
import { destinationsData } from '../../utils/data';

const TopDestination = () => {
    const settings = {
        dots: false,
        infinite: true,
        autoplay: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    infinite: false,
                    dots: true,
                    autoplay: true,
                },
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: false,
                    dots: true,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    autoplay: true,
                    prevArrow: false,
                    nextArrow: false,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    prevArrow: false,
                    nextArrow: false,
                },
            },
        ],
    };
    return (
        <div>
            <section className="tours_section slick_slider">
                <Container>
                    <Row>
                        <Col md="12">
                            <div className="main_heading">
                                <h1> Top Destination For Your Next Vacation </h1>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col md="12">
                            <Slider {...settings}>
                                {destinationsData.map((destination, inx) => (
                                    <Cards destination={destination} key={inx} />
                                ))}
                            </Slider>
                        </Col>
                    </Row>
                </Container>
            </section>
        </div>
    )
}

export default TopDestination
